import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominaComponent {
  idEmpresa
  idNomina
  data = {}
  nomina = {}
  permisos = {}
  diferenciaSuministros = 0
  mostrarSeccionSaldos = false
  promise

  constructor ($q, $state, NominasNomina, NominasNominaPermisos) {
    this.$q = $q
    this.$state = $state
    this.NominasNomina = NominasNomina
    this.NominasNominaPermisos = NominasNominaPermisos
  }

  $onInit () {
    this.promise = this.$q.all([
        this.NominasNomina.get(this.idEmpresa, this.idNomina)
          .then((data) => this.nomina = data),
        this.NominasNominaPermisos.get(this.idEmpresa, this.idNomina)
          .then((data) => this.permisos = data),
      ])
      .then(() => {
        this.diferenciaSuministros = this.nomina.Contiene_Informacion
          ? Math.abs(this.nomina.Suministro - this.nomina.Suministro_Calculado)
          : 0

        this.mostrarSeccionSaldos = this.nomina.pueblo_bonito

        this.data = {
          id_moneda: this.nomina.ID_Moneda,
          id_tipo_nomina: parseInt(this.nomina.id_tipo_nomina),
          tipo_cambio: this.nomina.Tipo_Cambio,
          tipo_cambio_fecha: this.nomina.tipo_cambio_fecha,
          sucursal: this.nomina.sucursal,
          suministro: this.nomina.Suministro,
          status: this.nomina.Status,
          status_acumulado: this.nomina.status_acumulado,
          status_calculado: this.nomina.status_calculado,
          status_maquilado: this.nomina.status_maquilado,
          status_cotizado: this.nomina.status_cotizado,
          status_aprobado: this.nomina.status_aprobado,
          status_pagado: this.nomina.status_pagado,
          status_timbrado: this.nomina.status_timbrado,
        }
      })
  }

  cambioNomina () {
    this.$state.go(this.$state.current, {idNomina: this.idNomina})
  }
}

module.component('nomina', {
  controller: NominaComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idNomina: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/component.js